import { ConfirmDialog } from '@gogame/components';
import { useDateFormat } from '@gogame/intl-ts';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { removeComment } from 'scenes/Gallery/GalleryPage/Creatives/Comments/sources/comments';

import { remove, commentsQuery } from '../queryKeyFactory';

export const useRemove = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const dateFormat = useDateFormat({ template: 'LL' });

  const removeMutation = useMutation(remove(), removeComment, {
    successMessage: () => `Comment deleted`,
    refreshOptions: {
      queryKey: commentsQuery.all(),
    },
  });

  const handleAction = async ({ author, date, ...params }) => {
    await showModal({
      title: 'Delete Comment?',
      confirmActionLabel: 'Delete',
      bodyText: `by ${author.name} ${dateFormat(date)}`,
    });
    await removeMutation.mutateAsync(params);
  };

  return [handleAction, removeMutation];
};
